import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, BUTTON_TYPES, Svg, COLORS
} from 'day8-react/build/new-components';
import { Dialog, hooksHelpers } from 'day8-ui';

const CrewfinderExtraModal = ({
  className, title, description, icon, isIncluded, isViewPage
}) => {
  const [on, toggle] = hooksHelpers.useToggle();
  return (
    <div className={className}>
      <div className={`dui-text-center ${isViewPage && ('dui-flex')}`}>
        {!isViewPage && <h3 className="dui-text-sm dui-text-center dui-whitespace-nowrap">{title}</h3>}
        <Button
          onClick={toggle}
          buttonType={BUTTON_TYPES.NO_STYLE}
        >
          <div className="dui-relative">
            <Svg className="icon--xl" name={icon} fill={COLORS.BLACK} />
            <div className="dui-bg-white dui-rounded-full dui-absolute dui-top-0 dui-right-0 dui-padding-[1px] dui-shadow-md">
              {isIncluded ? (
                <Svg className="icon--sm" name="check-circle-fill" fill={COLORS.SUCCESS} />
              ) : (
                <Svg className="icon--sm" name="cross-circle-fill" fill={COLORS.ERROR} />
              )}
            </div>
          </div>
        </Button>
        {isViewPage && (
          <div className="dui-ml-4">
            <Button className="dui-flex dui-flex-col dui-items-start" onClick={toggle} buttonType={BUTTON_TYPES.NO_STYLE}>
              <h3 className="dui-text-sm dui-whitespace-nowrap">{title}</h3>
              <p className="dui-text-sm dui-text-gray-400 dui-text-left">{description.substring(0, 60)}...</p>
            </Button>
          </div>
        )}

      </div>
      <Dialog scrollable open={on} onOpenChange={toggle}>
        <div>
          <div className="">
            <h2>{title}</h2>
            <Svg className="icon--xl dui-my-4" name={icon} fill={COLORS.BLACK} />
            <p>{description}</p>
          </div>
          <hr className="dui-border-solid dui-border-bottom dui-border-gray-400 dui-my-6" />
          <div className="dui-flex dui-items-center">
            <p className="dui-text-gray-400 dui-text-sm dui-mr-4">{isIncluded ? 'This add-on has been verified by Yacht Week' : 'This add-on is not included in this booking'}</p>
            <Svg name={isIncluded ? 'check-circle-fill' : 'cross-circle-fill'} fill={isIncluded ? COLORS.SUCCESS : COLORS.ERROR} />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

CrewfinderExtraModal.propTypes = {
  isIncluded: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  isViewPage: PropTypes.bool
};

export default CrewfinderExtraModal;
